<template>
  <div><h1>Ideas</h1></div>
</template>
